import React from 'react'
import { useForm } from 'react-hook-form'
import { TextBox , Button} from '../../presentation'

export const UpdateEmail = ({onSubmit, hideModal}) => {
    const { register, handleSubmit } = useForm()
    const updateEmail=(data)=>{
        const {email}=data
        hideModal();
        onSubmit(email);
    }
    return (
        <div>
            <form onSubmit={handleSubmit(updateEmail)}>
                <div className="uk-modal-body" uk-overflow-auto="true">
                    Please enter the updated email id:

                    <TextBox
                        register={register}
                        type="email"
                        name="email"
                        placeholder="Updated Email"
                        required={true}
                    />
                    <Button
                        type="submit"
                        register={register}
                        label="SUBMIT"
                    />

                  </div>
            </form>
        </div>
    )
}
UpdateEmail.defaultProps={
    hideModal:(()=>{})
}
